import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {authStorage, ensureValidSession} from "../../services/authService";
import {UserStatsProvider} from "../../contexts/UserStatsContext";

type GuardState = "granted" | "denied";

export function RequireAuth() {
    const location = useLocation();
    const [status, setStatus] = useState<GuardState>("granted");

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                await ensureValidSession();
                if (mounted) {
                    setStatus("granted");
                }
            } catch {
                authStorage.clear();
                if (mounted) {
                    setStatus("denied");
                }
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    if (status === "denied") {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return (
        <UserStatsProvider>
            <Outlet />
        </UserStatsProvider>
    );
}
